import { PeopleSuggestion } from 'owa-search-service';
import { OR_SEPARATOR } from '../searchConstants';
import { createFormattedStringWithPrefix } from './searchQueryStringHelper';
import { isFeatureEnabled } from 'owa-feature-flags';
import { PeopleSearchPrefix } from '../store/schema/PeopleSearchPrefix';

export default function createPersonaSearchQueryString(
    personaSuggestion: PeopleSuggestion,
    peopleSearchPrefix: PeopleSearchPrefix
): string {
    const singlePersonaQueries: string[] = [];
    let isDisplayNameValid: boolean = true;

    if (isFeatureEnabled('sea-peopleSuggestions-toFromHints-queryText')) {
        if (personaSuggestion.EmailAddresses !== null) {
            personaSuggestion.EmailAddresses.forEach((email: string) => {
                singlePersonaQueries.push(
                    createFormattedStringWithPrefix(email, peopleSearchPrefix)
                );
            });
        }
    } else if (isFeatureEnabled('sea-peopleSuggestions-toFromHints-matchQueryText')) {
        if (personaSuggestion.EmailAddresses !== null) {
            singlePersonaQueries.push(
                createFormattedStringWithPrefix(
                    personaSuggestion.EmailAddresses[0],
                    peopleSearchPrefix
                )
            );
        }
    } else {
        if (personaSuggestion.DisplayName !== null) {
            // validate that DisplayName does not contain invalid characters
            const reg = /[^a-zA-Z\d\s:]/;
            isDisplayNameValid = !reg.test(personaSuggestion.DisplayName);
            if (isDisplayNameValid) {
                singlePersonaQueries.push(
                    createFormattedStringWithPrefix(
                        personaSuggestion.DisplayName,
                        peopleSearchPrefix
                    )
                );
            }
        }

        if (personaSuggestion.EmailAddresses !== null) {
            personaSuggestion.EmailAddresses.forEach((email: string) => {
                if (
                    (email !== personaSuggestion.DisplayName && isDisplayNameValid) ||
                    !isDisplayNameValid
                ) {
                    singlePersonaQueries.push(
                        createFormattedStringWithPrefix(email, peopleSearchPrefix)
                    );
                }
            });
        }
    }

    // Joining all the queries with an OR
    return singlePersonaQueries.join(OR_SEPARATOR);
}
